import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import ApiRequest from './ApiRequest';
import { ApiEndpoints } from './ApiEndpoints';

const PermissionContext = createContext({ status: 'loading', permissionSlugs: new Set(), hasPermission: () => false, refreshPermissions: () => {} });
export const usePermissions = () => useContext(PermissionContext);

export function PermissionProvider({ children }) {
  const [status, setStatus] = useState('loading');
  const [permissionSlugs, setPermissionSlugs] = useState(new Set());

  const refreshPermissions = useCallback(async () => {
    try {
      const response = await ApiRequest('GET', ApiEndpoints.rbac.myPermissions);
      setPermissionSlugs(new Set((response.permissions || []).map((permission) => permission.slug)));
      setStatus('ready');
    } catch (error) {
      setPermissionSlugs(new Set());
      setStatus(error.response?.status === 403 ? 'ready' : 'error');
    }
  }, []);

  useEffect(() => {
    refreshPermissions();
    const interval = window.setInterval(refreshPermissions, 10000);
    const onFocus = () => refreshPermissions();
    window.addEventListener('focus', onFocus);
    return () => { window.clearInterval(interval); window.removeEventListener('focus', onFocus); };
  }, [refreshPermissions]);

  const value = useMemo(() => ({
    status, permissionSlugs, refreshPermissions,
    hasPermission: (slug) => status === 'ready' && permissionSlugs.has(slug)
  }), [status, permissionSlugs, refreshPermissions]);

  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
}
